// extracted by mini-css-extract-plugin
export default {"image":"style_image__vi86u","imageHiddenMobile":"style_imageHiddenMobile__V3z4b"};